import { Branch, Product, BrandInfo } from '../types';

export const SITE_CONFIG = {
  brandName: "Carbon Case SV",
  tagline: "Exclusive Carbon Fiber Cases",
  logo: "/CCSV_LOGO.svg",

  colors: {
    primary: "#FFFFFF", // White
    background: "#000000",
  },

  contact: {
    whatsapp: '+50379225906',
    hours: 'Lunes a Viernes: 8:00 AM - 5:00 PM | Sábado: 8:00 AM - 12:00 MD'
  },

  heroBanners: [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1616348436168-de43ad0db179?q=80&w=1920&auto=format&fit=crop',
      title: 'CARBON CASE SV',
      subtitle: 'Protección premium para tu dispositivo',
      position: 'center'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1592910793732-c7fb555d3f27?q=80&w=1920&auto=format&fit=crop',
      title: 'DISEÑO Y RESISTENCIA',
      subtitle: 'Fibra de carbono real',
      position: 'center'
    }
  ],

  whatsapp: {
    defaultMessage: "Hola, estoy interesado en el siguiente producto: ",
  },

  socialMedia: {
    instagram: "https://www.instagram.com/carboncase.sv/",
    facebook: "https://www.facebook.com/p/Carbon-Case-Sv-61560841956188/",
    tiktok: "https://www.tiktok.com/@carboncasesv",
  },

  footer: {
    description: "Especialistas en carbon case y accesorios de fibra de carbono real en El Salvador. Ofrecemos la mejor protección premium para iPhone y Samsung con envíos a todo el país.",
    copyright: `© ${new Date().getFullYear()} Carbon Case SV. Todos los derechos reservados.`,
  },

  promotions: {
    freeShipping: {
      enabled: true,
      minAmount: 100,
      message: "🎉 Envío gratis en compras mayores a $100"
    },
    premiumDiscount: {
      enabled: true,
      percentage: 10,
      message: "10% OFF en productos premium"
    }
  }
};



export const BRANCHES: Branch[] = [
  {
    id: 'online',
    name: 'Tienda en Línea',
    address: 'San Salvador, El Salvador',
    phones: ['+503 7922 5906'],
    mapsUrl: '#'
  },
];

export const PRODUCT_CATEGORIES = [
  'Case',
  'Accesorios'
] as const;

export const POPULAR_BRANDS: BrandInfo[] = [
  {
    name: 'Apple',
    logo: '/brand-logos/apple.svg',
    popularModels: ['iPhone 15', 'iPhone 14', 'iPhone 13']
  },
  {
    name: 'Samsung',
    logo: '/brand-logos/samsung.svg',
    popularModels: ['Galaxy S24', 'Galaxy S23', 'Galaxy Z Fold', 'Galaxy Tab']
  },
  {
    name: 'Accesorios',
    logo: '/brand-logos/accessories.svg',
    popularModels: ['Portaplaca']
  }
];

export const MOCK_PRODUCTS: Product[] = [];


